import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import { openBlankSearchPage } from '@/utils/common'
import Auth from '@/utils/Auth'
import debounce from 'lodash.debounce'
import './topHeaderSearch.scss'

export default {
    name: 'TopHeaderSearch',
    data() {
        return {
            type: 'article',
            keyword: '',
            showPopper: false,
            showHistory: false
        }
    },

    computed: {
        ...mapState('search', [
            'isGlobalSearchLoading'
        ]),

        ...mapGetters('search', [
            'articleOptions',
            'accountOptions',
            'historyOptions'
        ]),

        placeholder: function () {
            if (this.type === 'article') {
                return '请输入关键字搜索文章'
            } else if (this.type === 'account') {
                return '请输入关键字搜索账号'
            }
        }
    },

    watch: {
        '$route.query': {
            handler(val) {
                let parsedType = val.type
                if (!['article', 'account'].includes(parsedType)) {
                    parsedType = 'article'
                }
                if (this.$route.path === '/search') {
                    this.type = parsedType
                    this.keyword = val.keyword || ''
                } else {
                    this.keyword = ''
                    this.updateSearchKeyword('')
                }
            },
            deep: true
        }
    },

    mounted() {
        const { type, keyword } = this.$route.query
        let parsedType = type
        if (!['article', 'account'].includes(type)) {
            parsedType = 'article'
        }
        this.type = parsedType
        this.keyword = keyword || ''
    },

    methods: {
        ...mapMutations('common', [
            'updateSearchType',
            'updateSearchKeyword',
            'pushLog',
            'updateAuthDialogType'
        ]),

        ...mapActions('search', [
            'fetchRelationWord'
        ]),

        setType(type) {
            this.type = type
            this.updateSearchType(type)
        },

        onFocus() {
            if (!Auth.isLogin()) {
                this.updateAuthDialogType('login')
            } else {
                // 首次触发，没有关键词时
                if (this.keyword.trim() === '') {
                    this.showHistory = true
                    this.fetchRelationWord({ sType: this.getTypeValue() }).then(len => {
                        if (len > 0) {
                            this.showPopper = true
                        }
                    })
                } else { // 有关键词，再次获得焦点时
                    this.fetchRelationWord({ sType: this.getTypeValue(), sKeyword: this.keyword }).then(len => {
                        if (len > 0) {
                            this.showPopper = true
                        }
                    })
                }
            }
        },

        onBlur() {
            this.showPopper = false
        },

        onClear() {
            this.keyword = ''
            this.updateSearchKeyword(this.keyword)
        },

        onKeyup(e, keyword) {
            if (!e.shiftKey && e.keyCode === 13) {
                if (keyword.trim() === '') return
                this.search()
            }
        },

        onInput: debounce(function () {
            if (this.keyword.trim() !== '') {
                this.showHistory = false
                this.showPopper = true
                this.updateSearchKeyword(this.keyword)
                this.fetchRelationWord({ sType: this.getTypeValue(), sKeyword: this.keyword })
            } else { // 删除为空时
                this.showPopper = false
                this.fetchRelationWord({ sType: this.getTypeValue() }).then(len => {
                    if (len > 0) {
                        this.showHistory = true
                        this.showPopper = true
                    }
                })
            }
        }, 300),

        /**
         * 搜索账号
         */
        searchAccount(name) {
            this.keyword = this.removeMarkHtml(name)
            this.updateSearchType('account')
            this.type = 'account'
            this.baseSearch()
            this.showPopper = false
        },

        /**
         * 从历史记录关键词点击搜索
         */
        searchByHistory(keyword) {
            this.keyword = keyword
            this.baseSearch()
            this.showPopper = false
        },

        /**
         * 搜索按钮
         */
        search: debounce(function () {
            this.baseSearch()
        }, 300),

        baseSearch() {
            if (this.keyword.trim()) {
                const curPath = this.$route.path
                this.updateSearchKeyword(this.keyword)
                const query = {
                    type: this.type,
                    from: curPath.slice(1, curPath.length),
                    keyword: this.keyword
                }

                if (curPath === '/search') {
                    // 防止重复搜索
                    if (this.$route.query.keyword === this.keyword) {
                        return
                    }

                    this.$router.replace({
                        query: query
                    })
                } else {
                    openBlankSearchPage(this.$router, {
                        path: 'search',
                        query
                    })
                }
            }
        },

        /**
         * 文章下拉匹配搜索
         */
        popperSearch(label) {
            const parsedLabel = this.removeMarkHtml(label)
            this.keyword = parsedLabel
            this.baseSearch()
        },

        /**
         * 将后端返回的搜索关键字包裹HTML去除
         */
        removeMarkHtml(str) {
            const reg = /(<script(\s|\S)*?<\/script>)|(<style(\s|\S)*?<\/style>)|(<!--(\s|\S)*?-->)|(<\/?(\s|\S)*?>)/g
            return str.replace(reg, '')
        },

        getTypeValue() {
            if (this.type === 'article') {
                return 1
            } else if (this.type === 'account') {
                return 2
            }
        }
    },

    render() {
        return (
            <div class='top-header-search'>
                <div class='input-wrap'>
                    <div class='opacity-bg'>
                        <div class='switch'>
                            <div class={`switch-btn ${this.type === 'article' && 'active'}`} onClick={() => this.setType('article')}>搜文章</div>
                            <div class={`switch-btn ${this.type === 'account' && 'active'}`} onClick={() => this.setType('account')}>搜账号</div>
                        </div>
                        <div class='split' />
                        <div class='input'>
                            <el-popover
                                placement='bottom'
                                trigger='manual'
                                width={this.showHistory ? '300' : '500'}
                                visible-arrow={false}
                                popper-class='globalSearchPopper'
                                v-model={this.showPopper}
                            >
                                <el-input
                                    v-model={this.keyword}
                                    ref='inputRef'
                                    size='mini'
                                    onInput={this.onInput}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onClear={this.onClear}
                                    slot='reference'
                                    placeholder={this.placeholder}
                                    clearable
                                    nativeOnKeyup={e => this.onKeyup(e, this.keyword)}
                                />
                                {
                                    this.isGlobalSearchLoading && (
                                        <div
                                            class='loading'
                                            v-loading={this.isGlobalSearchLoading}
                                            element-loading-text='努力搜索中'
                                            element-loading-spinner='el-icon-loading'
                                        />
                                    )
                                }

                                {
                                    // 历史记录
                                    (!this.isGlobalSearchLoading && this.showHistory) && (
                                        <div class='history-list'>
                                            <div class='list pb__m'>
                                                {
                                                    this.historyOptions && this.historyOptions.options.map(item => (
                                                        <div class='list-item' onClick={() => this.searchByHistory(this.removeMarkHtml(item))}>
                                                            <div class='keyword' domPropsInnerHTML={item} />
                                                            {/* <el-button type='text' size='mini'>
                                                                <i class='el-icon-close el-icon--right' />
                                                            </el-button> */}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {/* <div class='action'>
                                                <el-button type='text' size='small' icon='el-icon-refresh'>清空历史</el-button>
                                            </div> */}
                                        </div>
                                    )
                                }

                                {
                                    // 搜索结果
                                    (!this.isGlobalSearchLoading && !this.showHistory) && (
                                        <div class='search-result'>
                                            {
                                                this.articleOptions && (
                                                    <div class='result'>
                                                        <div class='result-header'>
                                                            <div class='label account'>
                                                                <i class='iconfont iconyibaowen' />
                                                                <div domPropsInnerHTML={this.articleOptions.label} />
                                                            </div>
                                                        </div>
                                                        <div class='result-list'>
                                                            {
                                                                this.articleOptions.options.map(item => (
                                                                    <div class='list-item'>
                                                                        <div class='label' domPropsInnerHTML={item.label} onClick={() => this.popperSearch(item.label)} />
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                ((this.articleOptions || this.accountOptions) && this.type !== 'account') && <div class='split' />
                                            }

                                            {
                                                this.accountOptions && (
                                                    <div class='result'>
                                                        <div class='result-header'>
                                                            <div class='label'>
                                                                <i class='el-icon-user-solid' />
                                                                <div domPropsInnerHTML={this.accountOptions.label} />
                                                            </div>
                                                        </div>
                                                        <div class='result-list'>
                                                            {
                                                                this.accountOptions.options.map(item => (
                                                                    <div class='list-item'>
                                                                        <el-avatar icon='el-icon-user-solid' size={22} src={item.sIcon} />
                                                                        <a class='label' domPropsInnerHTML={item.label} onClick={() => this.searchAccount(item.label)} />
                                                                        {
                                                                            item.iAuthen === 1 && <i class='iconfont iconrenzhenghao' />
                                                                        }
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </el-popover>
                        </div>
                        <i class='iconfont iconsearch'></i>
                    </div>
                </div>
                {/* <div class='action'>
                    <el-button size='medium' onClick={this.search}>搜索</el-button>
                </div> */}
            </div>
        )
    }
}
